<div class="about_us_wrap">
    <div class="our_mission_sections">
        <div class="our_mission_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mission_content">
                        <h1>デモ版でTrinkaを体験してください</h1>
                        <span>無料AIツールTrinkaを使えば瞬時に英文校正が行えます。ライティングがストレスフリーに。</span>
                        <!-- <a href="http://demo.trinka.ai/" target="_blank">今試してみて</a> -->
                        <a href="https://cloud.trinka.ai/signup?utm_source=try-a-demo&utm_medium=jp&utm_campaign=signup" target="_blank">今試してみて</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>学術論文・テクニカルライティングに特化した文章校正AIツール</h2>
                    <p>AI搭載の高精度の<a href="/grammar-checker" class="text-link">文法チェッカー</a>が瞬時に英文を校正。Trikaでは、様々なミスをハイライト表示し文脈に沿った改善案を提示します。これにより、英文ライティングの質を向上させられます。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>他のツールでは見つけられない複雑なミスも検出</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinkaが検出するのは単なる文法ミスにとどまりません。学術的な文章、科学系の文章のトーンやスタイルにそぐわない用法もチェックすることができます。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <h4>専門用語の選択</h4>
                            <p>Yield strength values, defined from <span class="wrong_text"> cycling</span> <span
                                    class="right_text"> cyclic</span> aging tests, are used for the parameterization of
                                the model.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>学術論文・テクニカルライティングに特化</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>研究者やテクニカルライターのために開発されたツールTrinkaでは、3000種以上の文法ミス、不適切な文構造などを検出します。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <h4>構文</h4>
                            <p>The virus <span class="wrong_text"> is not requiring</span> <span class="right_text">
                                    does not require</span> us to <span class="wrong_text">remain</span> <span
                                    class="right_text"> stay</span> away from our communities.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>各分野に特有の用法・スタイルに即して修正を提示</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>先行する数多くの優れた研究論文・学術文献を読み込んで学習したAIが、分野ごとの慣例に従った適切な修正案を提示します。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <h4>専門用語のスペリング</h4>
                            <p>Grind tissue in <span class="wrong_text">Trizol reagent</span> <span class="right_text">
                                    TRIzol® Reagent</span> using a disposable <span class="wrong_text">pestel</span>
                                <span class="right_text"> pestle</span> and centrifuge for 10 min at 4°C.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>校正ツールの概念を変える校正ツール</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>経験豊富な校正者や英文ライターのノウハウを活かして設計されたTrinkaだから、配慮が必要な文章も、繊細に校正することができます。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <h4>デリケートな語用のチェック</h4>
                            <p>Eighty-eight percent were male and <span class="wrong_text">committed</span> <span
                                    class="right_text"> died by</span> suicide at a mean age of 25.6 years.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>今すぐ、英文ライティングのスキルアップを</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" id="grammerSignUpButton">
                        <!-- <i class="fa fa-sign-in"></i> -->
                        <span>無料で登録する</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="testimonail_demo_page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonail_heading">
                    <h2>お客様の声</h2>
                    <p>Trinkaをご利用いただいたお客様の感想です。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png" alt="">
                    </div>
                    <p>とにかくTrinkaは素晴らしい。規範に則った文法修正や単語数削減など、文書校正を包括的に行ってくれるツールを開発してくれたことに頭が下がります。</p>
                    <div class="testimonals_footer">
                        <p>学術雑誌編集者 ― アメリカ</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png" alt="">
                    </div>
                    <p>Grammarlyでチェック済みだった文書をTrinkaで再チェックしたのですが、文法チェックのツールとしてはGrammarlyより優れています！インドからこんな優れたツールが生まれるなんて嬉しい限りです。</p>
                    <div class="testimonals_footer">
                        <p>放射線医師 ― インド</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png" alt="">
                    </div>
                    <p>Trinkaを実際に使い、その性能の高さに驚きました。論文の英語をチェックするためにこれまで使っていた別の英文チェッカーより格段に優れていたため、研究室の同僚にも薦めました。多くの研究者の方に使ってみてほしいです。</p>
                    <div class="testimonals_footer">
                        <p>PhD― イギリス</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>